import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Home, Search, HelpCircle, ArrowLeft } from 'lucide-react';
import './NotFound.css';

const NotFound = () => {
  useEffect(() => {
    // Add structured data for 404 page
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "404 - Page Not Found",
      "description": "The requested page could not be found on WealthCore",
      "url": window.location.href,
      "isPartOf": {
        "@type": "WebSite",
        "name": "WealthCore",
        "url": window.location.origin
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structuredData);
    script.id = 'not-found-structured-data';
    document.head.appendChild(script);

    return () => {
      const existingScript = document.getElementById('not-found-structured-data');
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <div className="not-found-page">
      <div className="not-found-container">
        <div className="not-found-content">
          <div className="not-found-icon">
            <div className="error-code">404</div>
          </div>
          
          <h1 className="not-found-title">Page Not Found</h1>
          <p className="not-found-description">
            The page you're looking for doesn't exist or has been moved.
          </p>

          <div className="not-found-actions">
            <Link to="/" className="btn-primary">
              <Home size={20} />
              Go to Homepage
            </Link>
            <Link to="/dashboard" className="btn-secondary">
              <ArrowLeft size={20} />
              Back to Dashboard
            </Link>
          </div>

          <div className="not-found-links">
            <h3>Popular Pages</h3>
            <div className="popular-links-grid">
              <Link to="/dashboard" className="popular-link">
                <div className="popular-link-icon">📊</div>
                <div>
                  <div className="popular-link-title">Dashboard</div>
                  <div className="popular-link-desc">Main overview</div>
                </div>
              </Link>
              <Link to="/individual-stock-analysis" className="popular-link">
                <div className="popular-link-icon">📈</div>
                <div>
                  <div className="popular-link-title">Stock Analysis</div>
                  <div className="popular-link-desc">Individual stocks</div>
                </div>
              </Link>
              <Link to="/bulk-stock-analysis" className="popular-link">
                <div className="popular-link-icon">🔍</div>
                <div>
                  <div className="popular-link-title">Bulk Analysis</div>
                  <div className="popular-link-desc">S&P 500 screener</div>
                </div>
              </Link>
              <Link to="/help" className="popular-link">
                <div className="popular-link-icon">❓</div>
                <div>
                  <div className="popular-link-title">Help & Support</div>
                  <div className="popular-link-desc">Get assistance</div>
                </div>
              </Link>
            </div>
          </div>

          {/* Structured Data for 404 page will be added via useEffect */}
        </div>
      </div>
    </div>
  );
};

export default NotFound;

